__turbopack_context__.v({
  "accordionSlideOverwrite": "relatedCalcCard-module-scss-module__ZUwnrq__accordionSlideOverwrite",
  "button": "relatedCalcCard-module-scss-module__ZUwnrq__button",
  "buttonIcon": "relatedCalcCard-module-scss-module__ZUwnrq__buttonIcon",
  "buttonText": "relatedCalcCard-module-scss-module__ZUwnrq__buttonText",
  "description": "relatedCalcCard-module-scss-module__ZUwnrq__description",
  "fadeIn": "relatedCalcCard-module-scss-module__ZUwnrq__fadeIn",
  "fadeOut": "relatedCalcCard-module-scss-module__ZUwnrq__fadeOut",
  "relatedCalcCard": "relatedCalcCard-module-scss-module__ZUwnrq__relatedCalcCard",
  "scaleIn": "relatedCalcCard-module-scss-module__ZUwnrq__scaleIn",
  "scaleOut": "relatedCalcCard-module-scss-module__ZUwnrq__scaleOut",
  "zoomIn": "relatedCalcCard-module-scss-module__ZUwnrq__zoomIn",
  "zoomOut": "relatedCalcCard-module-scss-module__ZUwnrq__zoomOut",
});
